attendeeList.animation('.am-animate-slide', [
    function () {
        return {
            enter: function (element, doneFn) {
                var $element = $(element);
                $element
                    .css({
                        'margin-top': '-' + $element.outerHeight(true) + 'px',
                        'z-index': '0'
                    })
                    .animate(
                        {
                            'margin-top': 0
                        },
                        {
                            duration: 400,
                            complete: function () {
                                // remove previously installed value
                                $element.css('z-index', '');
                                doneFn();
                            },
                            easing: 'swing'
                        }
                    );
            },

            leave: function (element, doneFn) {
                var $element = $(element);
                $element.css({ 'z-index': '0' }).animate(
                    { 'margin-top': '-' + $element.outerHeight(true) + 'px' },
                    {
                        duration: 400,
                        complete: doneFn,
                        easing: 'swing'
                    }
                );
            }
        };
    }
]);
